module.exports = __webpack_public_path__ + "static/img/3.0d2201b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/carouseImg/3.png
// module id = MLzS
// module chunks = 0